import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlSegment } from '@angular/router';

@Injectable()
export class ValidaModuloService implements CanActivate {
  userPerfil;
  lstModulos;
  constructor(private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    this.userPerfil = JSON.parse(sessionStorage.getItem('userPerfil'));
    //console.log(this.userPerfil);
    this.lstModulos = this.userPerfil.perfil.modulos;
    for (let index = 0; index < this.lstModulos.length; index++) {
      const modulo = this.lstModulos[index];
      if (this.validaModulo(modulo, route.url)) {
        return true;
      }
    }
    console.log("validaModulo");
    this.router.navigate(['prelogin']);
    return false;
  }

  validaModulo(modulo: any, url: UrlSegment[]) {
    if (url == modulo.url) {
      return true;
    } else {
      return false;
    }
  }

}